import {
  checkAreaCodeAvailability as checkAreaCodeAvailabilityApi,
  checkPhonePortability as checkPhonePortabilityApi,
  IAreaCodeAvailabilityResponse,
  IPortabilityCheckResponse
} from "../utils/fetch";
import IGlobalConfig from "../types/IGlobalConfig";
import { formatMmsApiErrorMessage } from "../utils/mmsApiErrorMessage";

export class MmsService {
  static async checkAreaCodeAvailability(
    config: IGlobalConfig,
    areaCode: string,
    charityId: string,
    serviceAccessToken: string
  ): Promise<IAreaCodeAvailabilityResponse> {
    try {
      return await checkAreaCodeAvailabilityApi(
        config?.adminServiceUrl,
        areaCode,
        charityId,
        serviceAccessToken
      );
    } catch (error) {
      console.error("Failed to check area code availability:", error);
      throw new Error(
        formatMmsApiErrorMessage(
          error,
          "Unable to check area code availability. Please try again."
        )
      );
    }
  }

  static async checkPortability(
    config: IGlobalConfig,
    phoneNumber: string,
    charityId: string,
    serviceAccessToken: string
  ): Promise<IPortabilityCheckResponse> {
    try {
      return await checkPhonePortabilityApi(
        config?.adminServiceUrl,
        phoneNumber,
        charityId,
        serviceAccessToken
      );
    } catch (error) {
      console.error("Failed to check phone portability:", error);
      throw new Error(
        formatMmsApiErrorMessage(
          error,
          "Unable to check phone portability. Please try again."
        )
      );
    }
  }
}
